import { EmployeeList } from './Employees.list'
import { EmployeeShow } from './Employees.show'

const resource = {
  list: EmployeeList,
  show: EmployeeShow,
}

export default resource
